// PRD 14 §4.3 — author/publisher cell.
// Inline format: Name + [Role Badge] + Email.
// Example: 강현우 [ROOT] hw.kang@carelink.co.kr

import type { TermAuthor } from '../types/terms.types';

interface AuthorCellProps {
  author: TermAuthor;
}

export function AuthorCell({ author }: AuthorCellProps) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span style={{ fontWeight: 500 }}>{author.name}</span>
      <span className="badge badge-outline">{author.authorGrade}</span>
      <span style={{ color: 'var(--muted-foreground)', fontSize: 'var(--font-size-sm)' }}>
        {author.email}
      </span>
    </span>
  );
}
